module.exports = __webpack_public_path__ + "img/1529380366.e58abc45.jpg";